import { AiMerchantApproval } from "@redotech/redo-model/conversation";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateAiFeedbackOnMessage = {
  name: "updateAiFeedbackOnMessage" as const,
  input: z.object({
    conversationId: zExt.objectId(),
    messageId: zExt.objectId(),
    messageIds: z.array(zExt.objectId()).optional(),
    approval: z
      .enum([
        AiMerchantApproval.APPROVED,
        AiMerchantApproval.DISAPPROVED,
        AiMerchantApproval.SKIPPED,
        AiMerchantApproval.NO_STATUS,
      ])
      .nullable(),
    reasoning: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
